import './Tooltip.css';
import {
  Popover,
  PopoverButton,
  PopoverContent,
  PopoverBody,
} from '@deere/fuel-react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import React from 'react';

const TooltipWidget = (props) => {
  return (
    <Popover>
      <PopoverButton className={'popoverButton'}>
        <InfoOutlinedIcon className="cardTooltip" />
      </PopoverButton>
      <PopoverContent
        placement={props.placement ? props.placement : 'left'}
        className={'popoverBody'}
      >
        <PopoverBody>{props.tooltip}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};
export default TooltipWidget;
